import React, { useState } from 'react';
import { MenuItem, TextField } from '@material-ui/core';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import { FormGridType } from '@sierralabs/forms-core';
import { useFormContext } from '../FormContext';
import ConfigFieldControl from './components/ConfigFieldControl';
export const FormConfigLayoutGrid = () => {
    const { formState, updateElement } = useFormContext();
    const element = formState.selectedFormElement;
    if (!element.config)
        element.config = {};
    const { config } = element;
    const [gridType, setGridType] = useState(config.grid || FormGridType.Vertical);
    return (React.createElement(React.Fragment, null,
        React.createElement(ConfigFieldControl, null,
            React.createElement(ToggleButtonGroup, { exclusive: true, size: 'small', value: gridType, onChange: (_, newGridType) => {
                    if (gridType === newGridType) {
                        // no change
                        return;
                    }
                    config.grid = newGridType;
                    // remove gridColumns if not grid
                    if (newGridType !== FormGridType.Grid) {
                        config.gridColumns = undefined;
                    }
                    updateElement({ config });
                    setGridType(newGridType);
                } }, Object.entries(FormGridType).map(([key, value]) => (React.createElement(ToggleButton, { key: key, value: key }, value))))),
        gridType === FormGridType.Grid && (React.createElement(ConfigFieldControl, null,
            React.createElement(TextField, { select: true, fullWidth: true, size: 'small', variant: 'outlined', label: 'Number of columns', value: config.gridColumns || '', onChange: event => {
                    config.gridColumns = parseInt(event.target.value) || undefined;
                    updateElement({ config });
                } },
                React.createElement(MenuItem, { value: 2 }, "2"),
                React.createElement(MenuItem, { value: 3 }, "3"),
                React.createElement(MenuItem, { value: 4 }, "4"))))));
};
export default FormConfigLayoutGrid;
//# sourceMappingURL=FormConfigLayoutGrid.js.map